import React from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  ButtonItem,
} from "devextreme-react/form";

export default function LivroParametroForm(data) {
  return (
    <div>
      <Form formData={data} colCount={6} labelLocation="top">
        <SimpleItem dataField={"codigo"} colSpan={2}>
          <Label text="Código" />
        </SimpleItem>
        <SimpleItem dataField={"numero"} colSpan={2}>
          <Label text="Número" />
        </SimpleItem>
        <SimpleItem
          dataField={"dataLei"}
          colSpan={2}
          editorType={"dxDateBox"}
          editorOptions={{ editorType: "date", width: "100%" }}
        >
          <Label text="Data da Lei" />
        </SimpleItem>
        <SimpleItem dataField={"titulo"} colSpan={3}>
          <Label text="Título" />
        </SimpleItem>
        <SimpleItem dataField={"fundamento"} colSpan={3}>
          <Label text="Fundamento" />
        </SimpleItem>
        <SimpleItem dataField={"diretor"} colSpan={3}>
          <Label text="Diretor" />
        </SimpleItem>
        <SimpleItem dataField={"cargoDiretor"} colSpan={3}>
          <Label text="Cargo do Diretor" />
        </SimpleItem>
        <SimpleItem dataField={"secretario"} colSpan={3}>
          <Label text="Secretario" />
        </SimpleItem>
        <SimpleItem dataField={"cargoSecretario"} colSpan={3}>
          <Label text="Cargo do Secretario" />
        </SimpleItem>
        <SimpleItem dataField={"obs"} editorType={"dxTextArea"} colSpan={6}>
          <Label text="Descrição" />
        </SimpleItem>
      </Form>
    </div>
  );
}
